import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Field, Panel, PageTitle } from "../../components/admin/Field";

export default function Account() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("A nova senha deve ter pelo menos 8 caracteres.");
    if (pw !== pw2) return toast.error("As senhas não coincidem.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Senha alterada. Outras sessões foram encerradas.");
      setCur("");
      setPw("");
      setPw2("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-account" className="space-y-6 max-w-xl">
      <PageTitle title="Minha conta" desc={`Conectado como ${user.email}`} />
      <Panel title="Alterar senha">
        <form onSubmit={submit} className="space-y-5">
          <Field label="Senha atual" type="password" autoComplete="current-password" value={cur} onChange={setCur} testid="account-current-password" />
          <Field label="Nova senha" type="password" autoComplete="new-password" value={pw} onChange={setPw} testid="account-new-password" hint="Mínimo de 8 caracteres." />
          <Field label="Confirmar nova senha" type="password" autoComplete="new-password" value={pw2} onChange={setPw2} testid="account-confirm-password" />
          <button type="submit" disabled={busy} data-testid="account-save-btn" className="btn-gold w-full h-12">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Salvar nova senha"}
          </button>
        </form>
      </Panel>
      <Panel title="Recuperação de acesso">
        <p className="text-sm text-zinc-400 leading-relaxed">Se esquecer a senha, use “Esqueci minha senha” na tela de login. Um link de redefinição, válido por 1 hora, será enviado para {user.email}.</p>
      </Panel>
    </div>
  );
}
